import { render, staticRenderFns } from "./TravelCard.vue?vue&type=template&id=0c9d6d88&scoped=true"
import script from "./TravelCard.vue?vue&type=script&lang=js"
export * from "./TravelCard.vue?vue&type=script&lang=js"
import style0 from "./TravelCard.vue?vue&type=style&index=0&id=0c9d6d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d6d88",
  null
  
)

export default component.exports